import {useCallback, useState} from 'react'

import type {PointerEventHandler} from 'react'

export interface UseHorizontalDragScrollResult<T extends HTMLElement = HTMLElement> {
  handlers: UseHorizontalDragScrollHandlers<T>
  isGrabbing: boolean
}

export interface UseHorizontalDragScrollHandlers<T extends HTMLElement = HTMLElement> {
  onPointerDown: PointerEventHandler<T>
  onPointerLeave: PointerEventHandler<T>
  onPointerMove: PointerEventHandler<T>
  onPointerUp: PointerEventHandler<T>
}

export const useHorizontalDragScroll = (): UseHorizontalDragScrollResult => {
  const [isGrabbing, setIsGrabbing] = useState(false)

  const setGrabbing = useCallback(() => setIsGrabbing(true), [setIsGrabbing])
  const unsetGrabbing = useCallback(() => setIsGrabbing(false), [setIsGrabbing])
  const onPointerMove: PointerEventHandler<HTMLDivElement> = useCallback(({currentTarget, movementX}) => {
    if (isGrabbing) {
      currentTarget.scrollLeft -= movementX
    }
  }, [isGrabbing])

  const handlers = {
    onPointerDown: setGrabbing,
    onPointerUp: unsetGrabbing,
    onPointerLeave: unsetGrabbing,
    onPointerMove,
  }

  return {
    isGrabbing,
    handlers,
  }
}
